import { z } from "zod";

const dias = z.coerce.number({ invalid_type_error: "Informe os dias." }).int("Dias inteiros.").min(1, "Mínimo de 1 dia.").max(3650);

/** Mesma regra do backend (AcessosService.validarLimites): atenção < inativa. */
export const configuracaoSchema = z
  .object({
    diasAtencaoInstituicao: dias,
    diasInativaInstituicao: dias,
    diasAtencaoUsuario: dias,
    diasInativoUsuario: dias,
  })
  .refine((c) => c.diasAtencaoInstituicao < c.diasInativaInstituicao, {
    path: ["diasInativaInstituicao"],
    message: "Precisa ser maior que o limite de atenção.",
  })
  .refine((c) => c.diasAtencaoUsuario < c.diasInativoUsuario, {
    path: ["diasInativoUsuario"],
    message: "Precisa ser maior que o limite de atenção.",
  });
